export default [
  {
    path: "/03d1a7ec62cd19d86a5jiwjic",
    children: [
      {
        path: "XyGHA03a61fe9b54605efc10f5500dsim",
        name: "order-list",
        meta: {
          title: "Orders",
          authRequired: true,
          acc: ["y10227"],
        },
        component: () => import("@/views/order/index.vue"),
      },
      //   {
      //     path: "XyGHA0042efda1241cd4a0b6a47d1709k0/:id?",
      //     name: "stocks-view",
      //     meta: {
      //       title: "Stock",
      //       authRequired: true,
      //       acc: ["y25981"],
      //     },
      //     component: () => import("@/views/stocks/details.vue"),
      //   },
      //   {
      //     path: "XyGHA04897e583a9c3785fb7db28ek0/:id?",
      //     name: "stocks-edit",
      //     meta: {
      //       title: "Edit Stock",
      //       authRequired: true,
      //       acc: ["y50075"],
      //     },
      //     component: () => import("@/views/stocks/create.vue"),
      //   },
    ],
  },
  // {
  //     path:"/order-management",
  //     name:"orders",
  //     meta: {
  //         title:"ORDERS"
  //     },
  //     component : () => import ("../views/ecommerce/orders.vue")
  // },
  // {
  //     path:"/order-details",
  //     name:"order-details",
  //     meta: {
  //         title:"ORDERS DETAILS"
  //     },
  //     component : () => import ("../views/ecommerce/order-details.vue")
  // }
];
